export const LF_CHANGE_LANGUAGE = 'LF_CHANGE_LANGUAGE';
export const LF_TOGGLE_MUTE = 'LF_TOGGLE_MUTE';
export const LF_SET_MUTE = 'LF_SET_MUTE';
export const LF_SET_VOLUME = 'LF_SET_VOLUME';
export const LF_SET_ZOOM = 'LF_SET_ZOOM';
export const LF_SET_TEXT_SIZE = 'LF_SET_TEXT_SIZE';
export const LF_TOGGLE_SIDE_MENU_SLIDER_VISIBILITY = 'LF_TOGGLE_SIDE_MENU_SLIDER_VISIBILITY';
export const LF_SELECT_CHARACTER = 'LF_SELECT_CHARACTER';
export const LF_SELECT_CHARACTER_SECTION = 'LF_SELECT_CHARACTER_SECTION';